import type { EmailDocument } from "../domain/types";
import { mapEmailBuilderValidationError } from "./mapEmailBuilderValidationError";
import type { TEmailBuilderValidationMessageDescriptor } from "./translateEmailBuilderValidationMessage";

export function emailBuilderApiErrorMessage(
  message: unknown,
  fallback: string,
  document: EmailDocument | null = null,
): TEmailBuilderValidationMessageDescriptor | string {
  if (typeof message === "string" && message.trim().length > 0) {
    return mapEmailBuilderValidationError(message.trim(), document);
  }

  return fallback;
}
